import React, { useEffect } from 'react';
import styled from 'astroturf/react';

import { Button } from 'js/design_system/Button';
import { Icon } from 'js/design_system/Icon';
import { BodyLink } from 'js/design_system/link/BodyLink';
import routes from 'js/core_pre_webpack/routes';
import $image_url from 'js/utils/image_url';
import { trackClick } from 'js/utils/trackClick';
import isMobile from 'js/utils/isMobile';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionEntity } from 'js/utils/impressions/watchImpressions';
import { fsEvent, initializeFullstory } from 'js/fullstory';
import { currentUser } from 'js/utils/user';
import { WorkId } from 'js/liswp/types';
import PlayIcon from 'js/svg/colorless/play_arrow.svg';

import { usePaperToPodcast } from './usePaperToPodcast';
import _FeedbackButton from "SimplePaperPodcast-FeedbackButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=FeedbackButton";
import _Container from "SimplePaperPodcast-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=Container";
import _ClickableArea from "SimplePaperPodcast-ClickableArea.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=ClickableArea";
import _ContentSection from "SimplePaperPodcast-ContentSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=ContentSection";
import _TitleContainer from "SimplePaperPodcast-TitleContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=TitleContainer";
import _WorkTitle from "SimplePaperPodcast-WorkTitle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=WorkTitle";
import _PlayerWithButtonContainer from "SimplePaperPodcast-PlayerWithButtonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PlayerWithButtonContainer";
import _PlayerContainer from "SimplePaperPodcast-PlayerContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PlayerContainer";
import _AudioPlayerWrapper from "SimplePaperPodcast-AudioPlayerWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=AudioPlayerWrapper";
import _AudioPlayer from "SimplePaperPodcast-AudioPlayer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=AudioPlayer";
import _PlaySection from "SimplePaperPodcast-PlaySection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PlaySection";
import _LoadingRow from "SimplePaperPodcast-LoadingRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=LoadingRow";
import _LoadingButtonContainer from "SimplePaperPodcast-LoadingButtonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=LoadingButtonContainer";
import _LoadingSpinner from "SimplePaperPodcast-LoadingSpinner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=LoadingSpinner";
import _LoadingContent from "SimplePaperPodcast-LoadingContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=LoadingContent";
import _LoadingText from "SimplePaperPodcast-LoadingText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=LoadingText";
import _LoadingSubtext from "SimplePaperPodcast-LoadingSubtext.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=LoadingSubtext";
import _PlayRow from "SimplePaperPodcast-PlayRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PlayRow";
import _PlayButton from "SimplePaperPodcast-PlayButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PlayButton";
import _PlayInfo from "SimplePaperPodcast-PlayInfo.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PlayInfo";
import _PlayLabel from "SimplePaperPodcast-PlayLabel.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PlayLabel";
import _PlayMeta from "SimplePaperPodcast-PlayMeta.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PlayMeta";
import _HeadphonesIcon from "SimplePaperPodcast-HeadphonesIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=HeadphonesIcon";
import _BottomSection from "SimplePaperPodcast-BottomSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=BottomSection";
import _FeedbackRow from "SimplePaperPodcast-FeedbackRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=FeedbackRow";
import _FeedbackInput from "SimplePaperPodcast-FeedbackInput.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=FeedbackInput";
import _FeedbackSuccess from "SimplePaperPodcast-FeedbackSuccess.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=FeedbackSuccess";
import _UpgradeLink from "SimplePaperPodcast-UpgradeLink.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=UpgradeLink";
import _ErrorContent from "SimplePaperPodcast-ErrorContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=ErrorContent";
import _PublishButton from "SimplePaperPodcast-PublishButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/SimplePaperPodcast.tsx?styleId=PublishButton";


type Props = {
  workId: WorkId;
  workTitle: string;
  showTitle?: boolean;
  impressionSource?: string;
  onsitePodcastPromotion?: boolean;
  onsitePodcastPromotionRevised?: boolean;
  showFeedbackSection?: boolean;
  onPlayerReady?: () => void;
  initialEpisode?: {
    id: number;
    generationStartedAt?: string | null;
    generationCompletedAt?: string | null;
    streamReadyAt?: string | null;
    transcriptCompletedAt?: string | null;
    visibility?: string;
    duration?: number | null;
  } | null;
};

// Store all podcast instances
const podcastInstances = new Map<WorkId, () => Promise<void>>();

export const SimplePaperPodcast: React.FC<Props> & {
  play: (workId?: WorkId) => Promise<void>;
} = ({
  workId,
  workTitle,
  showTitle = true,
  impressionSource = 'paper_to_podcast_profile',
  onsitePodcastPromotion = false,
  onsitePodcastPromotionRevised = false,
  showFeedbackSection = true,
  onPlayerReady,
  initialEpisode,
}) => {
  const {
    showPlayer,
    feedbackInput,
    loading,
    feedbackSubmitted,
    audioRef,
    setFeedbackInput,
    handlePlay,
    handlePause,
    onSubmitFeedback,
    isReady,
    hasError,
    isPremiumUser,
  } = usePaperToPodcast({ workId, impressionSource, initialEpisode });

  // Store this instance's handlePlay function
  React.useEffect(() => {
    podcastInstances.set(workId, handlePlay);

    // Cleanup when component unmounts
    return () => {
      podcastInstances.delete(workId);
    };
  }, [workId, handlePlay]);

  useEffect(() => {
    if (onsitePodcastPromotion && !currentUser?.admin) {
      initializeFullstory(currentUser ?? undefined);
      fsEvent('OnsitePodcastPromotion');
    }
  }, [onsitePodcastPromotion]);

  // Trigger onPlayerReady callback when the player becomes ready
  useEffect(() => {
    if (isReady && onPlayerReady) {
      onPlayerReady();
    }
  }, [isReady, onPlayerReady]);

  if (hasError) {
    return (
      <Container>
        <ErrorContent>
          <Icon name="error_outline" size={16} />
          <span>Unable to load podcast</span>
        </ErrorContent>
      </Container>
    );
  }

  return (
    <ImpressionWatcher
      style={{ width: '100%' }}
      source={`${impressionSource}.player`}
      entity_id={workId}
      entity_type={ImpressionEntity.Work}
      noBatch
      extra={{ workId }}
      onClick={(e) => e.preventDefault()}
    >
      <Container>
        <ClickableArea
          className="podcast-spotlight-target"
          onClick={loading ? undefined : handlePlay}
          style={{
            display: showPlayer ? 'none' : 'block',
            cursor: loading ? 'default' : 'pointer',
            opacity: loading ? 0.7 : 1,
          }}
        >
          <ContentSection>
            {showTitle && (
              <TitleContainer>
                <WorkTitle>{workTitle}</WorkTitle>
              </TitleContainer>
            )}

            <PlaySection>
              {loading ? (
                <LoadingRow>
                  <LoadingButtonContainer>
                    <LoadingSpinner
                      src={$image_url('value_props/premium-loading.gif')}
                    />
                  </LoadingButtonContainer>
                  <LoadingContent>
                    <LoadingText>Generating podcast...</LoadingText>
                    <LoadingSubtext>This will take a moment</LoadingSubtext>
                  </LoadingContent>
                </LoadingRow>
              ) : (
                <PlayRow>
                  <PlayButton>
                    <PlayIcon size={16} />
                  </PlayButton>

                  <PlayInfo>
                    <PlayLabel>Listen to Podcast Summary</PlayLabel>
                    <PlayMeta>Generated with AI • ~5 min</PlayMeta>
                  </PlayInfo>

                  <HeadphonesIcon>
                    <Icon name="headphones" size={16} />
                  </HeadphonesIcon>
                </PlayRow>
              )}
            </PlaySection>
          </ContentSection>
        </ClickableArea>

        <div style={{ display: showPlayer ? 'block' : 'none' }}>
          <ContentSection>
            {showTitle && (
              <TitleContainer>
                <WorkTitle>{workTitle}</WorkTitle>
              </TitleContainer>
            )}

            <PlayerWithButtonContainer>
              <PlayerContainer>
                <AudioPlayerWrapper>
                  <AudioPlayer
                    ref={audioRef}
                    controls
                    src="placeholder"
                    preload="none"
                    onPlay={handlePlay}
                    onPause={handlePause}
                    onLoadedMetadata={() => {
                      if (audioRef.current) {
                        audioRef.current.currentTime = 0;
                      }
                    }}
                    style={{ width: '100%' }}
                  >
                    Your browser does not support the audio element.
                  </AudioPlayer>
                </AudioPlayerWrapper>
              </PlayerContainer>
              {onsitePodcastPromotion && (
                <PublishButton
                  onClick={() => {
                    trackClick({
                      source: `${impressionSource}.publish_button`,
                      extra: {
                        work_id: workId,
                      },
                    });
                    if (onsitePodcastPromotionRevised) {
                      const upgradeUrl = isMobile()
                        ? '/upgrade?feature=ai_podcast&trigger=work_edit_promotion'
                        : '/upgrade?feature=ai_podcast&referrer=work_edit&trigger=work_edit_promotion';
                      window.location.href = upgradeUrl;
                    } else {
                      window.location.href =
                        '/upgrade?feature=ai_podcast&trigger=own_profile_promotion';
                    }
                  }}
                >
                  {onsitePodcastPromotionRevised
                    ? 'Publish podcast'
                    : 'Publish to Academia'}
                </PublishButton>
              )}
            </PlayerWithButtonContainer>
          </ContentSection>

          {showFeedbackSection && !onsitePodcastPromotion && (
            <BottomSection>
              {!feedbackSubmitted ? (
                <FeedbackRow>
                  <FeedbackInput
                    value={feedbackInput}
                    onChange={(e) => setFeedbackInput(e.target.value)}
                    placeholder="Share feedback..."
                  />
                  <FeedbackButton onClick={onSubmitFeedback} size="sm">
                    Send
                  </FeedbackButton>
                </FeedbackRow>
              ) : (
                <FeedbackSuccess>
                  <Icon name="check" size={14} />
                  <span>Thanks for the feedback!</span>
                </FeedbackSuccess>
              )}

              {!isPremiumUser && (
                <UpgradeLink>
                  <BodyLink
                    onClick={() => {
                      trackClick({
                        source: `${impressionSource}.upgrade_link`,
                        extra: {
                          work_id: workId,
                        },
                      });
                    }}
                    href={routes.upgrade_url({
                      feature: 'ai_podcast',
                      trigger: impressionSource,
                    })}
                  >
                    Create podcasts for your papers →
                  </BodyLink>
                </UpgradeLink>
              )}
            </BottomSection>
          )}
        </div>
      </Container>
    </ImpressionWatcher>
  );
};

// Method that allows external elements to trigger the play button
SimplePaperPodcast.play = async (workId?: WorkId) => {
  if (workId && podcastInstances.has(workId)) {
    // Play specific podcast by workId
    const handlePlay = podcastInstances.get(workId)!;
    await handlePlay();
  } else if (podcastInstances.size === 1) {
    // If only one podcast, play it
    const entryIterator = podcastInstances.entries().next();
    if (!entryIterator.done) {
      const [, handlePlay] = entryIterator.value;
      await handlePlay();
    }
  }
};

const FeedbackButton = /*#__PURE__*/styled(Button, null, {
  displayName: "FeedbackButton",
  styles: _FeedbackButton
});

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const ClickableArea = /*#__PURE__*/styled("div", null, {
  displayName: "ClickableArea",
  styles: _ClickableArea
});

const ContentSection = /*#__PURE__*/styled("div", null, {
  displayName: "ContentSection",
  styles: _ContentSection
});

const TitleContainer = /*#__PURE__*/styled("div", null, {
  displayName: "TitleContainer",
  styles: _TitleContainer
});

const WorkTitle = /*#__PURE__*/styled("h3", null, {
  displayName: "WorkTitle",
  styles: _WorkTitle
});

const PlayerWithButtonContainer = /*#__PURE__*/styled("div", null, {
  displayName: "PlayerWithButtonContainer",
  styles: _PlayerWithButtonContainer
});

const PlayerContainer = /*#__PURE__*/styled("div", null, {
  displayName: "PlayerContainer",
  styles: _PlayerContainer
});

const AudioPlayerWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "AudioPlayerWrapper",
  styles: _AudioPlayerWrapper
});

const AudioPlayer = /*#__PURE__*/styled("audio", null, {
  displayName: "AudioPlayer",
  styles: _AudioPlayer
});

const PlaySection = /*#__PURE__*/styled("div", null, {
  displayName: "PlaySection",
  styles: _PlaySection
});

const LoadingRow = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingRow",
  styles: _LoadingRow
});

const LoadingButtonContainer = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingButtonContainer",
  styles: _LoadingButtonContainer
});

const LoadingSpinner = /*#__PURE__*/styled("img", null, {
  displayName: "LoadingSpinner",
  styles: _LoadingSpinner
});

const LoadingContent = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingContent",
  styles: _LoadingContent
});

const LoadingText = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingText",
  styles: _LoadingText
});

const LoadingSubtext = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingSubtext",
  styles: _LoadingSubtext
});

const PlayRow = /*#__PURE__*/styled("div", null, {
  displayName: "PlayRow",
  styles: _PlayRow
});

const PlayButton = /*#__PURE__*/styled("div", null, {
  displayName: "PlayButton",
  styles: _PlayButton
});

const PlayInfo = /*#__PURE__*/styled("div", null, {
  displayName: "PlayInfo",
  styles: _PlayInfo
});

const PlayLabel = /*#__PURE__*/styled("div", null, {
  displayName: "PlayLabel",
  styles: _PlayLabel
});

const PlayMeta = /*#__PURE__*/styled("div", null, {
  displayName: "PlayMeta",
  styles: _PlayMeta
});

const HeadphonesIcon = /*#__PURE__*/styled("div", null, {
  displayName: "HeadphonesIcon",
  styles: _HeadphonesIcon
});

const BottomSection = /*#__PURE__*/styled("div", null, {
  displayName: "BottomSection",
  styles: _BottomSection
});

const FeedbackRow = /*#__PURE__*/styled("div", null, {
  displayName: "FeedbackRow",
  styles: _FeedbackRow
});

const FeedbackInput = /*#__PURE__*/styled("input", null, {
  displayName: "FeedbackInput",
  styles: _FeedbackInput
});

const FeedbackSuccess = /*#__PURE__*/styled("div", null, {
  displayName: "FeedbackSuccess",
  styles: _FeedbackSuccess
});

const UpgradeLink = /*#__PURE__*/styled("div", null, {
  displayName: "UpgradeLink",
  styles: _UpgradeLink
});

const ErrorContent = /*#__PURE__*/styled("div", null, {
  displayName: "ErrorContent",
  styles: _ErrorContent
});

const PublishButton = /*#__PURE__*/styled("button", null, {
  displayName: "PublishButton",
  styles: _PublishButton
});
